import { Label } from "reactstrap"
import { SubmitInstructionsInfo } from "./InfoBoxes"
import { AdCopyAssistant } from "./AdCopyAssistant"
import { Button } from "@progress/kendo-react-buttons"
import { useState, useContext } from "react"
import { adCopyAssistanFields, AdCopyAssistantProps } from '../services/interfaces';
import { Editor, EditorChangeEvent, EditorTools, EditorMountEvent,PasteCleanupSettings, EditorPasteEvent, EditorUtils} from '@progress/kendo-react-editor'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faMagicWandSparkles} from '@fortawesome/free-solid-svg-icons';
import { SubmissionContext } from "./SubmissionFormContext"
import { useThemeSwitcher } from 'react-css-theme-switcher';
import { Checkbox, CheckboxChangeEvent } from "@progress/kendo-react-inputs"
import sanitize from "sanitize-html"


function InstructionsForm(){
    const subContext = useContext(SubmissionContext);
    const [asstShow, setAsstShow]=useState(false);
    const [adCopy, setAdCopy]=useState("");
    const [adInstructions, setInstructions]=useState("");
    const [asstProps, setAsstProps]=useState<AdCopyAssistantProps>({
        presets:{
            formType:"NEW",
            action:"",
            unitType:"",
            maxLength:10,
            emojis:false,
            hashtags:false,
            style:"",
            prompt:""
        },
        onConfirm:updateAdCopy,
        onClose:hideAsst
    })
    const { switcher, themes, currentTheme, status } = useThemeSwitcher();

    function hideAsst(){
        setAsstShow(false);
    }

    function showAsst(events: React.MouseEvent<HTMLButtonElement, MouseEvent>): void {
        events?.preventDefault();
        if (subContext?.submitForm.adCopy!=""){
            const regex = /<[^>]*>/g;
            const prompt = subContext?.submitForm.adCopy.replace(regex, '');;
            setAsstProps(prevObject => ({
                ...prevObject,
                presets: {
                    ...prevObject.presets,
                    prompt: prompt||"",
                    formType:"EDIT"
                }
            }))
        }
        setAsstShow(true);
    }

    function adCopyChange(event: EditorChangeEvent){
        setAdCopy(event.html);
        subContext?.setSubmitForm(prevObject=>({...prevObject,adCopy:event.html}));  
    }

    function instructionsChange(event: EditorChangeEvent){
        console.log(event.html);
        setInstructions(event.html);
        subContext?.setSubmitForm(prevObject=>({...prevObject,instructions:event.html}));  
    }

    function infChange(event:CheckboxChangeEvent){
        subContext?.setSubmitForm(prevObject=>({...prevObject,instructionsNotFollowed:event.value}));  
    }

    function addCorrChange(event:CheckboxChangeEvent){
        subContext?.setSubmitForm(prevObject=>({...prevObject,additionalCorrections:event.value}));  
    }

    function updateAdCopy(retval:string){
        console.log("AI Response: " + retval);
        setAdCopy(retval);
        subContext?.setSubmitForm(prevObject=>({...prevObject,adCopy:retval}));        
        setAsstShow(false);
    }

    const styles = currentTheme === "dark"
        ? `
            p {
                font-family: Arial, sans-serif;
                color: #ffffff;
            }
        `
        :
        `
            p {
                font-family: Arial, sans-serif;
                color: #000000;
            }
        ` ;
    const onMount = (event: EditorMountEvent) => {
        const iframeDocument = event.dom.ownerDocument;
        const style = iframeDocument.createElement('style');
        style.appendChild(iframeDocument.createTextNode(styles));
        iframeDocument.head.appendChild(style);
    };

    const { pasteCleanup, sanitize, sanitizeClassAttr, sanitizeStyleAttr, removeAttribute, replaceImageSourcesFromRtf } =
    EditorUtils;
    const pasteSettings: PasteCleanupSettings={
        convertMsLists:true,
        stripTags:"none"
    }

    const htmlSanitize=(event:EditorPasteEvent)=>{
        let html=pasteCleanup(sanitize(event.pastedHtml), pasteSettings);
        if (event.nativeEvent.clipboardData){
            html=replaceImageSourcesFromRtf(html,event.nativeEvent.clipboardData);
        }
        console.log(html);
        return html;
    }



    const {Bold,Italic,Underline,OrderedList,UnorderedList}=EditorTools;

    return(
        <>
        <Label className="mb-2">Instructions and notes (Not appearing in the ad)</Label>
        {subContext?.submitForm.subType=="CR"?
            <>
            <div><Checkbox label='Supplied instructions were not followed (Describe below)' onChange={infChange} checked={subContext?.submitForm.instructionsNotFollowed}/></div>
            <div><Checkbox label='Additional corrections required' onChange={addCorrChange} checked={subContext?.submitForm.additionalCorrections}/></div>
            </>
        :null}
        <Editor resizable={true} tools={[[Bold,Italic, Underline],[OrderedList,UnorderedList]]} style={{height:200}} value={subContext?.submitForm.instructions} onChange={instructionsChange} data-bs-theme={currentTheme} onMount={onMount} onPasteHtml={htmlSanitize}/>
        {subContext?.submitForm.prCheck!=true?<><div className="mt-3 mb-2"><Label>Ad copy (Appearing in the ad)</Label> <Button onClick={showAsst}><FontAwesomeIcon icon={faMagicWandSparkles}></FontAwesomeIcon>&nbsp;Ad Copy Assistant</Button></div>
        <Editor resizable={true} tools={[[Bold,Italic, Underline],[OrderedList,UnorderedList]]} style={{height:200}} value={subContext?.submitForm.adCopy} onChange={adCopyChange} data-bs-theme={currentTheme} onMount={onMount} onPasteHtml={htmlSanitize}/></>:null}
        {asstShow?<AdCopyAssistant {...asstProps}/>:null}
        </>
    )
}

export const SubmitInstructions=(
    <div>
        <h5>INSTRUCTIONS / AD COPY:</h5>
        <SubmitInstructionsInfo/>
        <InstructionsForm/>
    </div>
)


